import axios from 'axios';

import lstModules from 'common/json/lstModules.json';

const httpURL = lstModules['main'].url + ':' + lstModules['main'].port;
var tokenid = localStorage.getItem("tokenid");
const wingId = parseInt(localStorage.getItem('wingId')) || 0;


export const getAvailabilityStatusSvc = (sectionId, sessionId, callback) => {
    // console.log("getAvailabilityStatusSvc called");
    const formData = new FormData();
    formData.append("sectionId", sectionId);
    formData.append("sessionId", sessionId);
    let obj = { status: "Success", message: "" }
    axios({
        url: httpURL + '/sms/tt/v2/tt_schedule/list_status',
        method: "POST",
        headers: { 'tokenid': tokenid },
        data: formData,
        withCredentials: true,
    }).then((response) => {
        // console.log('response in getAvailabilityStatusSvc', response);
        obj.status = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        if (response.data.SvcStatus === "Success") {
            obj.lstStatus = response.data.lstStatus;
        }
        callback(obj);
    }).catch((error) => {
        obj.status = "Exception";
        obj.message = error;
        callback(obj);
    });
}